import Icon, { ICON_COLORS, ICON_SIZES, ICON_TYPES } from './Icon';

export default Icon;
export { ICON_TYPES, ICON_COLORS, ICON_SIZES };
